import { BaseProvider } from './base-provider';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "./http-helper.service";
import * as i3 from "@angular/common/http";
import * as i4 from "./ls-helper.service";
// import { TransactionService } from 'src/app/pages/transaction/services/transaction.service';
export class UserProcessProfileService extends BaseProvider {
    constructor(globals, httpHelper, http, ls) {
        super();
        this.globals = globals;
        this.httpHelper = httpHelper;
        this.http = http;
        this.ls = ls;
        this.proponent = [];
        this.profiles = [];
        this.dataChange = new Subject();
        this.isNew = false;
        this.cities = [];
        this.countries = [];
        this.states = [];
        this.baseUrl = "userProcessProfile";
    }
    getUserProcessProfiles(processId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/both/' + processId;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.profiles = data;
                resolve(data);
            }, (error) => {
                //console.log(error);
                reject(error);
            });
        });
    }
    getProponentProfile(processId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/proponent/' + processId;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.proponent = data;
                resolve(data);
            }, (error) => {
                //console.log(error);
                reject(error);
            });
        });
    }
    search(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUserProfile' +
                '/admin/' + params.userId +
                '/term/' + params.term +
                '/page/' + params.pageNumber +
                '/size/' + params.pageSize;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.list = data.Data;
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
    getLookups() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + 'adminUserProfile' +
                '/admin/lookups';
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.cities = data.Data.cities;
                this.countries = data.Data.countries;
                this.states = data.Data.states;
                resolve(data);
            }, err => { reject(err); });
        });
    }
}
UserProcessProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserProcessProfileService_Factory() { return new UserProcessProfileService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpHelperService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.LsHelperService)); }, token: UserProcessProfileService, providedIn: "root" });
